var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5039_704)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.0733,
    cy: 10.0733,
    r: 3.07335,
    fill: "#FF0000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8182,
    cy: 10.1818,
    r: 3.18182,
    fill: "#EF3345"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5039_704",
    x: 0,
    y: 0,
    width: 20.1467,
    height: 20.1467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_5039_704"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabError);
export default __webpack_public_path__ + "static/media/tab_error.e0f71a1c59048648d0e397b8d4ad21ba.svg";
export { ForwardRef as ReactComponent };